export const COLS_WIDGET = 34
